module.exports = __webpack_public_path__ + "static/media/0_2019_07_01-3.51a094c1.jpg";